<template>
  <div class="c-featuredArticles">
    <!-- Loading (Error) ...  -->
    <load-indicator request="articles" />
    <!-- Loaded -->
    <ul v-if="featArticles">
      <li
        v-for="a in featArticles"
        :key="a.Id"
      >
        <f-link
          :has-text-decoration="false"
          :to="{
            name: 'article',
            params: {
              id: a.Id,
              slug: getSlug(a.Title)
            },
            props: true
          }"
          :link-class="getIconClass(a)"
        >
          <component :is="getIconType(a)" width="160" />
          {{ a.Title }}
        </f-link>
      </li>
    </ul>
  </div>
</template>

<script>
import slug from 'slug'
import FLink from '@justeat/f-link'
import {
  BagBinocularsBgIcon,
  BagHelpBgIcon,
  BagListenBgIcon,
  BagMoneyBgIcon,
  BagSadBgIcon,
  BagSorryBgIcon
} from '@justeat/f-vue-icons'
import LoadIndicator from './LoadIndicator.vue'

export default {
  name: 'FeaturedArticles',
  components: {
    FLink,
    BagBinocularsBgIcon,
    BagHelpBgIcon,
    BagListenBgIcon,
    BagMoneyBgIcon,
    BagSadBgIcon,
    BagSorryBgIcon,
    LoadIndicator
  },
  props: {
    featArticles: {
      type: [Array, null],
      default: null
    }
  },
  methods: {
    getIconClass(article) {
      return article.LabelNames.find(l => l.match('icon_')) || null
    },
    getIconType(article) {
      const iconLabel = article.LabelNames.find(l => l.match('icon_')) || null

      switch (iconLabel) {
        case 'icon_basket':
        case 'icon_order':
        case 'icon_review':
          return BagListenBgIcon
        case 'icon_clock':
        case 'icon_late':
          return BagBinocularsBgIcon
        case 'icon_payment':
          return BagMoneyBgIcon
        case 'icon_delivery':
        case 'icon_food':
          return BagSadBgIcon
        case 'icon_rejected':
        case 'icon_default':
        default:
          return BagSorryBgIcon
      }
    },
    getSlug(title) {
      return slug(title, { lower: true })
    }
  }
}
</script>
